<section class="relative flex flex-col w-full h-full min-h-screen gap-2 text-xs">
  <div class="flex justify-between w-full h-20">
    <div class="flex w-64 h-full">
      <img src="assets/images/Logo_Actemium.svg" class="-mt-10" />
    </div>
    <div class="mt-2 text-2xl font-bold tracking-wider uppercase">BORDEREAU DE LIVRAISON</div>
  </div>
  <div class="flex justify-between w-full h-14">
    <div class="w-1/2">
      <div class="w-24 -mt-16 h-14">
        <img
          alt="vinci-energies-logo"
          src="data:image/svg+xml;base64,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" />
      </div>
    </div>
    <div class="w-1/2 pl-24">
      <div class="h-full bg-gray-300 w-52">
        <ngx-barcode6
          [bc-value]="shipmentData.entityBarcode"
          bc-width="2"
          bc-height="56"
          [bc-text-margin]="0"
          [bc-margin]="0"
          [bc-margin-top]="0"
          [bc-margin-bottom]="0"
          [bc-margin-left]="0"
          [bc-margin-right]="0"
          [bc-display-value]="true" />
      </div>
    </div>
  </div>
  <div class="flex w-full gap-8">
    <div class="w-1/2 border border-black">
      <div class="w-full p-1 break-all border-b border-black">
        <b>Objet : {{ shipmentData.description }}</b>
      </div>
      <div class="w-full p-1 break-all border-b border-black">
        <b>A l’attention de :</b>
        {{ shipmentData.destination_user.full_name }} {{ shipmentData.destination_user.mail }} -
        {{ shipmentData.destination_user.phone }}
      </div>
      <div class="flex w-full font-bold border-b border-black">
        <div class="flex-1 p-1 border-r border-black">Client</div>
        <div class="flex-1 p-1 border-r border-black">N° d’affaire</div>
        <div class="flex-1 p-1">Nom d’affaire</div>
      </div>
      <div class="flex min-h-[2rem] w-full">
        <div class="flex-1 w-1/3 p-1 break-all border-r border-black">{{ shipmentData.client }}</div>
        <div class="flex-1 w-1/3 p-1 break-all border-r border-black">{{ shipmentData.business_ref }}</div>
        <div class="flex-1 w-1/3 p-1 break-all">{{ shipmentData.business_des }}</div>
      </div>
    </div>
    <div class="flex flex-col flex-1 px-16">
      <span class="mb-5 -mt-2 text-base font-bold text-blue-900">{{ shipmentData.entityBarcode }}</span>
      <div class="flex border">
        <div class="w-1/2">
          <div class="flex-1 p-1 break-all border-r">Poids :</div>
          <div class="flex-1 p-1 break-all border-t border-r">Dimensions :</div>
        </div>
        <div class="w-1/2">
          <div class="flex-1 p-1 break-all">{{ shipmentData.weight.toFixed(2) }} Kg</div>
          <div class="flex-1 p-1 break-all border-t">{{ shipmentData.dimensions }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="h-12 pl-2">
    <b>Commande Client :</b>
    {{ shipmentData.comment }}
  </div>
  <div class="w-1/2 p-1 font-bold border border-black">
    Date d’émission : Le {{ shipmentData.packagedAt }} À Oullins
  </div>
  <div class="flex w-full">
    <div class="flex-1 h-40 border border-black">
      <div class="p-1 font-bold text-center border-b border-black">Adresse de livraison</div>
      <div class="p-1">
        <div class="flex flex-col">
          <div class="flex-1 mt-3">{{ shipmentData.address.street }}</div>
          <div class="flex-1">{{ shipmentData.address.zip_code }} {{ shipmentData.address.city }}</div>
          <div class="flex-1">{{ shipmentData.address.country }}</div>
        </div>
      </div>
    </div>
    <div class="flex-1 border border-l-0 border-black mt-9">
      <div class="p-1 font-bold text-center border-b border-black">Expéditeur</div>
      <div class="p-1 mt-2">
        CESA / Actemium Lyon Logistics
        <br />
        <br />
        105 Avenue Jean Jaurès
        <br />
        69600 OULLINS France
      </div>
    </div>
  </div>
  <span class="-mt-1.5 pl-2">Dossier suivi en interne par : {{ userNameAndEmail }}</span>
  <table class="mt-4">
    <thead>
      <tr class="font-bold">
        <th class="p-2">Référence</th>
        <th class="p-2">Désignation</th>
        <th class="p-2">Quantité</th>
        <th class="p-2">N° entité</th>
      </tr>
    </thead>
    <tbody>
      <tr class="even:bg-gray-100" *ngFor="let article of shipmentData.articles">
        <td class="py-1 pl-2">{{ article.reference || 'N/A' }}</td>
        <td class="py-1 pl-2 whitespace-break-spaces">{{ article.truncatedDesignation }}</td>
        <td class="py-1 pl-2">{{ article.quantity | prettyQuantity }}</td>
        <td class="py-1 pl-2">{{ article.barcode }}</td>
      </tr>
      <tr class="italic even:bg-gray-100" *ngFor="let article of shipmentData.added_articles">
        <td class="py-1 pl-2">{{ article.reference || 'N/A' }}</td>
        <td class="py-1 pl-2 whitespace-break-spaces">{{ article.truncatedDesignation }}</td>
        <td class="py-1 pl-2">{{ article.quantity | prettyQuantity }}</td>
        <td class="py-1 pl-2">{{ shipmentData.entityBarcode }}</td>
      </tr>
    </tbody>
  </table>
  <div class="mt-12 text-right">
    <span>
      Vous en souhaitant bonne réception, nous vous prions d'agréer, l'expression de nos salutations distinguées
    </span>
    <br />
    <span class="font-bold">
      Service Logistique Actemium : GRP-ACTEMIUMLYONLOGISTICS-MAGASIN&#64;dom1.vinci-energies.net
    </span>
  </div>
  <div class="text-[0.5rem] leading-3">
    <b>CESA</b>
    <br />
    Tél. : +33 (0)4 72 89 30 50
    <br />
    Email : logistics&#64;actemium.com
    <br />
    105 Avenue Jean Jaurès - 69600 Oullins
    <br />
    SAS au capital de 120 090€
    <br />
    SIREN : 403 009 483 - RCS Lyon - APE 7112B
    <br />
    N° TVA Intracommunautaire : FR91 403 009 483
  </div>
</section>
